import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/app/home', label: 'Home', icon: '🏠' },
  { to: '/app/cards', label: 'Cards', icon: '🃏' },
  { to: '/app/circle', label: 'Circle', icon: '👥' },
  { to: '/app/settings', label: 'Settings', icon: '⚙️' },
];

export function BottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-border-subtle bg-surface/95 backdrop-blur">
      <ul className="mx-auto flex w-full max-w-screen-sm items-stretch justify-between px-2 py-1">
        {tabs.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 rounded-lg px-3 py-2 text-xs ${
                  isActive ? 'text-sage' : 'text-text-muted'
                }`
              }
            >
              <span aria-hidden className="text-lg">{t.icon}</span>
              <span>{t.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
